module.exports = __webpack_public_path__ + "e9c477e8/img/chevron-left-icon.a5582236.svg";